'use client';
import { isValidElement } from 'react';
import { isArray, isObject } from '@s7/utils';

function removeReactNodes(args) {
    if (isArray(args)) {
        return args.map((item)=>removeReactNodes(item));
    } else if (isObject(args)) {
        const result = {};
        for (const [key, value] of Object.entries(args)){
            if (/*#__PURE__*/ isValidElement(value)) {
                continue;
            } else if (isArray(value)) {
                result[key] = removeReactNodes(value);
            } else if (isObject(value)) {
                result[key] = removeReactNodes(value);
            } else {
                result[key] = value;
            }
        }
        return result;
    }
    return args;
}

export { removeReactNodes };
//# sourceMappingURL=removeReactNodes.js.map
